import {
    apiRequest,
    positionBknUpdate,
} from "../../../../../services/adapters/master/positionBknService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", positionBknUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository